/* CURIEux ™ — CTA scroll + review carousel */
(function(){
  if(window.__curInit) return; window.__curInit=true;

  function headerOffset(){
    var h=document.querySelector('sticky-header,.header-wrapper,header[role="banner"],#shopify-section-header');
    var hh=h?h.getBoundingClientRect().height:0;
    if(!hh||hh>200) hh=90;
    return hh+12;
  }
  function target(){
    return document.getElementById('cur-buybox')
      || document.querySelector('.quantity-break, quantity-break, .product-form__quantity, variant-selects, .product-form');
  }
  function scrollToBuy(e){
    if(e){e.preventDefault();}
    var t=target(); if(!t) return;
    var y=t.getBoundingClientRect().top+window.pageYOffset-headerOffset();
    window.scrollTo({top:y,behavior:'smooth'});
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-cur-scroll]');
    if(b) scrollToBuy(e);
  });

  /* review carousels — native horizontal scroll + arrow buttons (swipeable) */
  function initCarousels(){
    document.querySelectorAll('[data-cur-carousel]').forEach(function(root){
      if(root.__init) return; root.__init=true;
      var track=root.querySelector('[data-cur-track]');
      var prev=root.querySelector('[data-cur-prev]');
      var next=root.querySelector('[data-cur-next]');
      if(!track) return;
      function amount(){
        var c=track.children[0];
        return c ? c.getBoundingClientRect().width + 16 : track.clientWidth;
      }
      if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-amount(),behavior:'smooth'});});
      if(next)next.addEventListener('click',function(){track.scrollBy({left:amount(),behavior:'smooth'});});
    });
  }
  if(document.readyState!=='loading') initCarousels();
  else document.addEventListener('DOMContentLoaded',initCarousels);
})();
